import {ILauncherServiceFactory} from '../../../launcher-service-factory.interface';
import {makeConfigurationArea} from '../make-configuration-area';
import {LOCAL_STORAGE_OVERRIDES_KEYS} from '../../../orbit-configs-storage/configs-storage.service';
import {BooleanFieldDefinition} from '../../fields-definitions/boolean-field-definition';
import {OrbitConfigOverridesFieldDefinition} from './orbit-config-overrides-field-definition';

export function makeLocalStorageOverridesArea(services: ILauncherServiceFactory) {
    return makeConfigurationArea('', services, {
        [LOCAL_STORAGE_OVERRIDES_KEYS.IS_IP_WHITELISTED]: new BooleanFieldDefinition('SE IsIPWhiteListed'),
        [LOCAL_STORAGE_OVERRIDES_KEYS.ORBIT_CONFIG_OVERRIDES]: new OrbitConfigOverridesFieldDefinition('Orbit Config Overrides'),
    });
}